import React, { useState, useEffect } from 'react';
import { helpHttp } from '../../helpers/helpHttp';
import { BASE_API } from '../../api/Globals';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { Button } from 'primereact/button';
import { useNavigate } from 'react-router-dom';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import { Tag } from 'primereact/tag';
import { Dropdown } from 'primereact/dropdown';
import { Dialog } from 'primereact/dialog';
import EditUser from './edit';
import { InputSwitch } from 'primereact/inputswitch';

import Menu from '../../components/sturtural/Menu';
import { Tooltip } from 'primereact/tooltip';
import { storage } from '../../helpers/storage';


const ListaUsuarios = () => {

    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState({ loading: false, id: 0 });
    const [getUsuarios, setUsuarios] = useState([]);
    const [filters1, setFilters1] = useState(null);
    const [globalFilterValue1, setGlobalFilterValue1] = useState('');
    const [getDisplayBasic, setDisplayBasic] = useState(false);

    const [getEditModal, setEditModal] = useState(false);
    const [getUser, setUser] = useState(null);
    const [checked, setChecked] = useState(false);

    const perfil = storage.get('perfilid');

    useEffect(() => {
        if (![1, 5, 9, 10, 11, 12, 19].includes(parseInt(perfil))) {
            return navigate('/login');
        }
    }, [perfil]);

    let url = `${BASE_API}Usuarios/EjecutarUsuarios`;

    useEffect(() => {
        setLoading(true);
        helpHttp().post(url, {
            body: {
                "opcion": "O",
                "IdUsuario": 0,
                "Usuario": "",
                "Password": "",
                "Nombre": "",
                "TipoPerfil": perfil,
                "IdTienda": 0,
                "Activo": true
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.ITEMS !== null) {
                let jsonUsuarios = res.ITEMS;

                if (jsonUsuarios.length > 0) {

                    setUsuarios(jsonUsuarios);
                    initFilters1();
                } else {
                    setUsuarios(null);
                }

            }
            setLoading(false);
        });
    }, [url]);

    const showTipoUsuario = (rowData) => {
        return <Tag rounded className="mr-2" value={rowData.TipoUsuario.toUpperCase()} style={{ background: '#9b2f3e30', color: '#9b2f3e' }}></Tag>;
    }

    const showStatus = (rowData) => {
        return (
            <>
                <div style={{display: 'flex', justifyContent: 'center'}}>
                    <Tooltip target=".custom-target-icon" />
                    <div className='custom-target-icon flex' data-pr-tooltip={rowData.Activo == true ? 'Desactivar' : 'Activar'} data-pr-position='top'>
                        <InputSwitch  id='estilodeSwitc' checked={rowData.Activo} onChange={(e) => handleChamge_switch(rowData)} />
                    </div>
                    <div>
                        <button type="button" className="p-button p-component p-button-text p-button-icon-only" style={{paddingTop: 0}} onClick={(e) => handleChamge_form_edit(rowData)}>
                            <span className={`p-button-icon p-c pi pi-pencil custom-target-icon`} data-pr-tooltip='Editar' data-pr-position='top'></span>
                            <span className="p-button-label p-c">&nbsp;</span>
                            <span className="p-ink"></span>
                        </button>
                    </div>
                </div>


            </>
        );
    }

    const handleChamge_switch = (rowData) => {
        setLoadingSubmit({ loading: true, id: rowData.IdUsuario });
        helpHttp().post(url, {
            body: {
                "opcion": "B",
                "IdUsuario": rowData.IdUsuario,
                "Usuario": "",
                "Password": "",
                "Nombre": "",
                "TipoPerfil": 0,
                "IdTienda": 0,
                "Activo": (rowData.Activo)
            },
            headers: {
                "Content-Type": "application/json; charset=utf-8",
                "Accept": "application/json",
                'Authorization': `Bearer ${storage.get('token')}`
            }
        }).then(res => {
            if (res.SUCCESS === true) {
                const updateData = {
                    IdUsuario: rowData.IdUsuario,
                    Usuario: rowData.Usuario,
                    Password: rowData.Password,
                    Nombre: rowData.Nombre,
                    Activo: (rowData.Activo ? false : true),
                    IdTienda: rowData.IdTienda,
                    Tienda: rowData.Tienda,
                    IdTipoUsuario: rowData.IdTipoUsuario,
                    TipoUsuario: rowData.TipoUsuario
                }

                onComponentUpdate(updateData);
            } else {

            }
            setLoadingSubmit({ loading: false, id: 0 });
        });
    }

    const handleChamge_form_edit = (rowData) => {
        setUser(rowData);
        setEditModal(true)
    }

    const handleChamge_close_modal = () => {
        setUser(null);
        setEditModal(false);
    }

    const onComponentUpdate = (updateData) => {
        let newData = getUsuarios.map((el) =>
            (el.IdUsuario === updateData.IdUsuario ? updateData : el)
        );
        setUsuarios(newData);
    }

    const showTienda = (rowData) => {
        if (rowData.IdTienda === null) {
            return <label>N/A</label>
        } else if (rowData.IdTienda > 0) {
            return <label>{rowData.Tienda}</label>
        } else {
            return "..."
        }
    }

    const onGlobalFilterChange1 = (e) => {
        const value = e.target.value;

        let _filters1 = { ...filters1 };
        _filters1['global'].value = value;

        setFilters1(_filters1);
        setGlobalFilterValue1(value);
    }

    const renderHeader1 = () => {
        return (
            <div className='col-12'>
                <span className="p-input-icon-left w-full">
                    <i className="pi pi-search" />
                    <InputText className='w-full' value={globalFilterValue1} onChange={onGlobalFilterChange1} placeholder="Búsqueda general" />
                </span>
                {/* <Button type="button" label="Limpiar" className="p-button-outlined" onClick={clearFilter1} /> */}
            </div>
        )
    }

    const initFilters1 = () => {
        setFilters1({
            'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
            'Usuario': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'Nombre': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'TipoUsuario': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },
            'Tienda': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] }
        });
        setGlobalFilterValue1('');
    }

    const clearFilter1 = () => {
        initFilters1();
    }

    const header1 = renderHeader1();

    const rightToolbarTemplate = () => {
        return (<Button label="Nuevo usuario" icon="pi pi-plus" className="p-button-success mr-2" onClick={() => navigate('/configuracion/usuario/crear')} />)
    }

    const statuses = [
        'unqualified', 'qualified', 'new', 'negotiation', 'renewal', 'proposal'
    ];

    const statusFilterTemplate = (options) => {
        return <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterCallback(e.value, options.index)} itemTemplate={statusItemTemplate} placeholder="Select a Status" className="p-column-filter" showClear />;
    }

    const statusItemTemplate = (option) => {
        return <span className={`customer-badge status-${option}`}>{option}</span>;
    }

    const basicDialogFooter = <Button type="button" label="Aceptar" onClick={() => setDisplayBasic(false)} icon="pi pi-check" className="p-button-secondary" />;

    return (
        <>
            <div>
                <Menu link='filtro' />

                <div className="col-12">
                    <div className="card">
                        <h4 style={{ textAlign: 'center', marginTop: '10px' }}>USUARIOS</h4>
                        <div className='col-12 flex' style={{ marginBottom: '10px' }}>
                            <div className='col-6 text-left' style={{ alignSelf: 'center' }}>
                                <label style={{ fontSize: '14px' }}>Total <label style={{fontWeight: '600'}}>{(getUsuarios?.length > 0 ? getUsuarios?.length : 0)}</label></label>
                            </div>
                            <div className='col-6 text-right'>
                                <Button label="Nuevo usuario" icon="pi pi-plus" className="p-button-success mr-2" style={{ background: '#9b2f3e', border: 'none' }} onClick={() => navigate('/configuracion/usuario/crear')} />
                            </div>
                            
                        </div>

                        <DataTable
                            value={getUsuarios}
                            className="p-datatable-gridlines"
                            rows={50}
                            showGridlines
                            paginator
                            filterDisplay="menu"
                            dataKey="IdUsuario"
                            loading={loading}
                            responsiveLayout="scroll"
                            emptyMessage="No se encontraron usuarios."
                            filters={filters1}
                            header={header1}>

                            <Column header="Usuario" field="Usuario" />
                            <Column header="Nombre" field="Nombre" style={{ fontWeight: '700' }} />
                            <Column header="Sede" field="Tienda" body={showTienda} />
                            <Column header="Tipo usuario" field="TipoUsuario" body={showTipoUsuario} />
                            <Column
                                header="Acciones"
                                body={showStatus}
                                style={{ textAlign: "center", minWidth: '5rem' }}
                                filterElement={statusFilterTemplate}
                            />
                        </DataTable>
                    </div>
                </div>
            </div>

            <EditUser visible={getEditModal} user={getUser} close={handleChamge_close_modal} onComponentUpdate={onComponentUpdate} us={(e) => { setUsuarios(e); }} />

        </>
    );
}

export default ListaUsuarios;